
export interface IPagingDetail {
    records: number;
    noOfRecords: number;
    page: number;
    pageNo: number;
    sortOrder: number;
    skipRecords: number;
    pageSize: number;
}

export class PagingDetail implements IPagingDetail {
    records: number;
    noOfRecords: number;
    page: number;
    pageNo: number;
    sortOrder: number;
    skipRecords: number;
    pageSize: number;
}


